/**
 * Route path registry.
 *
 * Mirrors the routes declared in `src/app/router.tsx`. Provided as a single
 * source of truth for navigation links. Does NOT change routing behavior.
 */
export const ROUTES = {
  dashboard: '/',
  orcamentos: '/orcamentos',
  orcamentosEditor: '/orcamentos/editor',
  orcamentosPro: '/orcamentos/pro',
  orcamentosWorkspace: '/orcamentos/workspace',
  solutionBuilder: '/solution-builder',
  configurador: '/configurador',
  knowledgeBase: '/knowledge-base',
  baseConhecimento: '/base-conhecimento',
  recomendacoes: '/recomendacoes',
  clientes: '/clientes',
  produtos: '/produtos',
  search: '/search',
  comparador: '/comparador',
  comparadorInteligente: '/comparador-inteligente',
  otimizador: '/otimizador',
  ia: '/ia',
  salesWorkbench: '/sales-workbench',
  settings: '/settings',
  integrations: '/integrations',
  system: '/system',
  inteligenciaProduto: '/inteligencia-produto',
  historico: '/historico',
  oportunidades: '/oportunidades',
  configuracoes: '/configuracoes',
  configuracoesPrecificacao: '/configuracoes/precificacao',
  configuracoesFornecedores: '/configuracoes/fornecedores',
  configuracoesIntegracoes: '/configuracoes/integracoes',
  configuracoesAutomacoes: '/configuracoes/automacoes',

  // Public / status routes.
  login: '/login',
  unauthorized: '/401',
  forbidden: '/403',
  serverError: '/500',
  notFound: '/404',
} as const

export type RouteKey = keyof typeof ROUTES
export type RoutePath = (typeof ROUTES)[RouteKey]
